const mapping: Record<string, string> = {
  id: 't=>t.Id',
  name: 't=>t.Name',
}

export const mapSortTicketImportParam = (key: string) => mapping[key]
